"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientImportRequest = void 0;
const class_validator_1 = require("class-validator");
const class_transformer_1 = require("class-transformer");
const ClientImportData_1 = require("./ClientImportData");
const ClientContactImportData_1 = require("./ClientContactImportData");
const ClientAddressImportData_1 = require("./ClientAddressImportData");
class ClientImportRequest {
}
exports.ClientImportRequest = ClientImportRequest;
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => ClientImportData_1.ClientImportData),
    __metadata("design:type", Array)
], ClientImportRequest.prototype, "data", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => ClientContactImportData_1.ClientContactImportData),
    __metadata("design:type", Array)
], ClientImportRequest.prototype, "contacts", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => ClientAddressImportData_1.ClientAddressImportData),
    __metadata("design:type", Array)
], ClientImportRequest.prototype, "addresses", void 0);
__decorate([
    (0, class_validator_1.IsIn)(['all', 'none', 'references']),
    __metadata("design:type", String)
], ClientImportRequest.prototype, "cleanMode", void 0);
